import { sendClientRequest } from '@/utils/client-request'

export const fetchProductByIdApi = (vendorId: string, productId: string) =>
  sendClientRequest({ url: `/product/${productId}`, method: 'GET', auth: false, headers: { Vendor: vendorId } as any })

export const fetchCategoriesApi = (vendorId: string) =>
  sendClientRequest({ url: '/categories', method: 'GET', auth: false, headers: { Vendor: vendorId } as any })
